import { graphClient } from '../graph-client'
import type { LiveCheckinTaskDefault } from '../../types/check-in'
import type { Response } from '../../types/response'
import { GET_LIVE_CHECKIN_TASKS_DEFAULTS } from './gql'

export namespace GetList {
  export interface Input {
    take?: number
    skip?: number
    active?: boolean
    deleted?: boolean
  }
  export interface Output {
    getLiveCheckinTasksDefaults: Response<LiveCheckinTaskDefault[]>
  }
}

class LiveCheckinTasksDefaultsService {
  async getList(params: GetList.Input) {
    const res = await graphClient.request<GetList.Output>(
      GET_LIVE_CHECKIN_TASKS_DEFAULTS,
      params,
    )
    return res?.getLiveCheckinTasksDefaults
  }
}

export const liveCheckinTasksDefaultsService = new LiveCheckinTasksDefaultsService()
